(() => {
  if (window.__supplySportCartUpsellV2Loaded) return;
  window.__supplySportCartUpsellV2Loaded = true;

  const pickerSelector = '[data-cart-upsell-option-picker], [data-cart-upsell-model-picker]';
  const openPickerSelector = '[data-cart-upsell-option-picker][open], [data-cart-upsell-model-picker][open]';
  const getCard = element => element?.closest('.cart-upsell-v2__card');

  const updateCardMedia = (card, imageUrl) => {
    if (!card || !imageUrl) return;
    const image = card.querySelector('.cart-upsell-v2__media-image');
    if (!image) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = imageUrl;
  };

  const closeOtherPickers = activePicker => {
    document.querySelectorAll(openPickerSelector).forEach(picker => {
      if (picker !== activePicker) picker.removeAttribute('open');
    });
  };

  const getVariantRecords = scope => Array.from(scope?.querySelectorAll('[data-cart-upsell-variant-record]') || []);

  const recordOptions = record => [
    record?.getAttribute('data-option-0') || '',
    record?.getAttribute('data-option-1') || '',
    record?.getAttribute('data-option-2') || ''
  ];

  const isAvailableRecord = record => record?.dataset.variantAvailable === 'true';

  const getOptionFields = scope => Array.from(scope?.querySelectorAll('[data-cart-upsell-option-field]') || [])
    .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));

  const getFieldIndex = field => Number(field?.dataset.optionIndex || 0);

  const setFieldValue = (field, value) => {
    if (!field) return;
    field.dataset.selectedValue = value || '';

    const picker = field.querySelector('[data-cart-upsell-option-picker]');
    if (picker) picker.dataset.selectedValue = value || '';

    field.querySelectorAll('[data-cart-upsell-selected-value]').forEach(node => {
      node.textContent = value || '';
    });

    field.querySelectorAll('[data-cart-upsell-option-value]').forEach(button => {
      const selected = button.dataset.optionValue === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  };

  const selectedValues = scope => {
    const values = [];
    getOptionFields(scope).forEach(field => {
      values[getFieldIndex(field)] = field.dataset.selectedValue || '';
    });
    return values;
  };

  const exactVariant = (records, values) => records.find(record => {
    if (!isAvailableRecord(record)) return false;
    const options = recordOptions(record);
    return values.every((value, index) => !value || options[index] === value);
  });

  const updateOptionAvailability = scope => {
    const records = getVariantRecords(scope);
    const values = selectedValues(scope);

    getOptionFields(scope).forEach(field => {
      const index = getFieldIndex(field);
      field.querySelectorAll('[data-cart-upsell-option-value]').forEach(button => {
        const candidate = button.dataset.optionValue || '';
        const available = records.some(record => {
          if (!isAvailableRecord(record)) return false;
          const options = recordOptions(record);
          if (options[index] !== candidate) return false;
          for (let earlier = 0; earlier < index; earlier += 1) {
            if (values[earlier] && options[earlier] !== values[earlier]) return false;
          }
          return true;
        });
        button.disabled = !available;
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    });
  };

  const applyVariantToCard = (scope, record) => {
    if (!scope || !record) return;
    const card = getCard(scope);
    const addButton = card?.querySelector('.cart-upsell-v2__add');
    const price = card?.querySelector('[data-cart-upsell-price]');

    if (addButton) addButton.dataset.variantId = record.dataset.variantId || '';
    if (price && record.dataset.variantPrice) price.textContent = record.dataset.variantPrice;
    updateCardMedia(card, record.dataset.variantImage);
  };

  const syncOptionScope = (scope, changedIndex = null) => {
    if (!scope) return null;
    const records = getVariantRecords(scope);
    const fields = getOptionFields(scope);
    if (!records.length) return null;

    let values = selectedValues(scope);
    let variant = exactVariant(records, values);

    if (!variant && changedIndex !== null) {
      variant = records.find(record => {
        if (!isAvailableRecord(record)) return false;
        const options = recordOptions(record);
        for (let index = 0; index <= changedIndex; index += 1) {
          if (values[index] && options[index] !== values[index]) return false;
        }
        return true;
      });

      if (variant) {
        const fallbackOptions = recordOptions(variant);
        fields.forEach(field => {
          const index = getFieldIndex(field);
          if (index > changedIndex) setFieldValue(field, fallbackOptions[index]);
        });
        values = selectedValues(scope);
      }
    }

    if (!variant) variant = exactVariant(records, values);
    if (!variant) variant = records.find(isAvailableRecord) || null;

    if (variant) {
      const options = recordOptions(variant);
      fields.forEach(field => {
        const index = getFieldIndex(field);
        if (!field.dataset.selectedValue) setFieldValue(field, options[index]);
      });
      applyVariantToCard(scope, variant);
    }

    updateOptionAvailability(scope);
    return variant;
  };

  const initializeOptionScopes = root => {
    (root || document).querySelectorAll('[data-cart-upsell-option-scope]:not([hidden])').forEach(scope => {
      syncOptionScope(scope);
    });
  };

  document.addEventListener('toggle', event => {
    const picker = event.target?.matches?.(pickerSelector) ? event.target : null;
    if (picker?.open) closeOtherPickers(picker);
  }, true);

  document.addEventListener('click', event => {
    const option = event.target.closest('[data-cart-upsell-option-value]');
    if (!option || option.disabled) return;

    event.preventDefault();
    const field = option.closest('[data-cart-upsell-option-field]');
    const picker = option.closest('[data-cart-upsell-option-picker]');
    const scope = option.closest('[data-cart-upsell-option-scope]');
    const optionIndex = getFieldIndex(field);

    setFieldValue(field, option.dataset.optionValue || '');
    syncOptionScope(scope, optionIndex);
    picker?.removeAttribute('open');
  });

  document.addEventListener('click', event => {
    const model = event.target.closest('[data-cart-upsell-model-option]');
    if (!model) return;

    event.preventDefault();
    const root = model.closest('[data-cart-upsell-group-root]');
    const card = getCard(model);
    const picker = model.closest('[data-cart-upsell-model-picker]');
    const handle = model.dataset.productHandle || '';
    const selectedModel = picker?.querySelector('[data-cart-upsell-selected-model]');
    const productLink = card?.querySelector('[data-cart-upsell-product-link]');

    root?.querySelectorAll('[data-cart-upsell-model-option]').forEach(button => {
      const selected = button === model;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    root?.querySelectorAll('[data-cart-upsell-option-scope][data-product-handle]').forEach(panel => {
      panel.hidden = panel.dataset.productHandle !== handle;
    });

    if (selectedModel) selectedModel.textContent = model.dataset.productTitle || '';
    if (productLink && model.dataset.productUrl) productLink.href = model.dataset.productUrl;

    const activeScope = Array.from(root?.querySelectorAll('[data-cart-upsell-option-scope][data-product-handle]') || [])
      .find(panel => panel.dataset.productHandle === handle);
    const variant = syncOptionScope(activeScope);
    if (!variant) {
      const price = card?.querySelector('[data-cart-upsell-price]');
      if (price && model.dataset.productPrice) price.textContent = model.dataset.productPrice;
      updateCardMedia(card, model.dataset.productImage);
    }

    picker?.removeAttribute('open');
  });

  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-bundle-variant]');
    if (!input) return;

    const fieldset = input.closest('[data-cart-bundle-selector]');
    const selectedTitle = fieldset?.querySelector('[data-cart-bundle-selected-title]');
    if (selectedTitle) selectedTitle.textContent = input.dataset.variantTitle || '';

    if (!fieldset?.hasAttribute('data-cart-bundle-second')) {
      const card = getCard(input);
      const labelImage = input.nextElementSibling?.querySelector('img');
      if (labelImage) updateCardMedia(card, labelImage.currentSrc || labelImage.src);
    }
  });

  document.addEventListener('click', event => {
    const tierButton = event.target.closest('[data-cart-bundle-quantity]');
    if (!tierButton) return;

    event.preventDefault();
    const offer = tierButton.closest('[data-cart-bundle-offer]');
    const card = getCard(tierButton);
    const quantity = Number(tierButton.dataset.cartBundleQuantity || 1);

    offer?.querySelectorAll('[data-cart-bundle-quantity]').forEach(button => {
      const active = button === tierButton;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const second = offer?.querySelector('[data-cart-bundle-second]');
    if (second) second.hidden = quantity !== 2;

    const addButton = card?.querySelector('[data-cart-bundle-add]');
    if (addButton) addButton.dataset.bundleQuantity = String(quantity);
  });

  document.addEventListener('click', event => {
    const addButton = event.target.closest('.cart-upsell-v2__add');
    if (!addButton) return;

    event.preventDefault();
    const card = getCard(addButton);
    const error = card?.querySelector('.cart-upsell-v2__error');
    const cart = document.querySelector('cart-drawer');
    const isBundleAdd = addButton.hasAttribute('data-cart-bundle-add');

    addButton.disabled = true;
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    const config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/json' } };

    if (!config.headers) config.headers = {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    if (isBundleAdd) {
      const quantity = Number(addButton.dataset.bundleQuantity || 1);
      const selectors = Array.from(card?.querySelectorAll('[data-cart-bundle-selector]') || []).slice(0, quantity);
      const counts = new Map();

      selectors.forEach(fieldset => {
        const selected = fieldset.querySelector('[data-cart-bundle-variant]:checked');
        if (!selected) return;
        const variantId = Number(selected.dataset.variantId || selected.value);
        counts.set(variantId, (counts.get(variantId) || 0) + 1);
      });

      const items = Array.from(counts, ([id, itemQuantity]) => ({ id, quantity: itemQuantity }));
      if (!items.length) {
        addButton.disabled = false;
        return;
      }

      const payload = { items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(section => section.section);
        payload.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(payload);
    } else {
      const variantId = addButton.dataset.variantId;
      if (!variantId) {
        addButton.disabled = false;
        return;
      }

      delete config.headers['Content-Type'];
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(section => section.section));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
    }

    fetch(routes.cart_add_url, config)
      .then(response => response.json())
      .then(response => {
        if (response.errors || response.status) {
          throw new Error(response.description || response.message || response.errors || 'Produkten kunde inte läggas till.');
        }

        if (cart && response.sections && typeof cart.renderContents === 'function') {
          cart.renderContents(response, true);
          requestAnimationFrame(() => initializeOptionScopes(document));
        } else {
          window.location.reload();
        }

        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      })
      .catch(err => {
        if (error) {
          error.textContent = err.message || 'Produkten kunde inte läggas till.';
          error.hidden = false;
        }
      })
      .finally(() => {
        if (document.body.contains(addButton)) addButton.disabled = false;
      });
  });

  document.addEventListener('click', event => {
    if (event.target.closest(pickerSelector)) return;
    document.querySelectorAll(openPickerSelector).forEach(picker => picker.removeAttribute('open'));
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(openPickerSelector).forEach(picker => picker.removeAttribute('open'));
  });

  initializeOptionScopes(document);
})();
